void import('@app').then(async ({ appBootstrap }) => {
  await appBootstrap();
}).catch(async (error) => {
  // eslint-disable-next-line no-console
  console.error('[shell] Fatal bootstrap error:', error);

  // Application Insights may not be initialized yet, so attempt a best-effort
  // beacon so fatal bootstrap crashes are not completely invisible in telemetry.
  try {
    const { getAppInsights } = await import('@sgi/af-shell-shared');
    const ai = getAppInsights?.().getValue?.();
    if (ai?.trackException) {
      ai.trackException({
        exception: error instanceof Error ? error : new Error(String(error)),
        properties: { source: 'fatal_bootstrap', href: globalThis.location?.href },
      });
      ai.flush?.();
    }
  } catch {
    // AI not available — nothing more we can do client-side.
  }
});
